export default __webpack_public_path__ + "static/tiles_top_tablet-8051291d34e9949f3a8b3bd029352b02.png";